import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    inject,
    Signal,
    signal,
    viewChild,
    WritableSignal
} from "@angular/core";
import {onEach, toObservable} from '../../utils/observable-utils';
import {AnalyticsService} from '../../logging/analytics.service';
import {Page} from "../../navigation/page";
import {MenuItemInCategory, MenuModel} from "../menu.model";
import {debounceTime, skip} from "rxjs";
import {ContentMessageComponent} from "../../notification/message/content-message.component";
import {MessageLevel} from "../../notification/message/message";
import {TranslateModule} from '@ngx-translate/core';
import {ModalPageLayoutComponent} from '../../page-layout/modal-page-layout/modal-page-layout.component';
import {IconComponent} from "../../ui-elements/icon/icon.component";
import {MenuItemPanelComponent} from "../menu-item-panel/menu-item-panel.component";
import {FormsModule} from '@angular/forms';

@Component({
    selector: "woa-menu-search-page",
    templateUrl: "./menu-search-page.component.html",
    styleUrl: "./menu-search-page.component.scss",
    providers: [{provide: Page, useExisting: MenuSearchPageComponent}],
    imports: [
        ContentMessageComponent,
        FormsModule,
        IconComponent,
        MenuItemPanelComponent,
        ModalPageLayoutComponent,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuSearchPageComponent extends Page {
    public menuModel: MenuModel = inject(MenuModel);
    private analyticsService: AnalyticsService = inject(AnalyticsService);

    MessageLevel = MessageLevel;

    protected readonly inputER: Signal<ElementRef> = viewChild.required("input");

    public itemsInCategories: WritableSignal<MenuItemInCategory[]> = signal<MenuItemInCategory[]>([]);
    public searchText: WritableSignal<string> = signal("");

    constructor() {
        super();

        onEach(toObservable(this.searchText).pipe(
            skip(1),
            debounceTime(1000)
        ), (searchText: string) => {
            void this.analyticsService.trackSearchInitiated();
            this.itemsInCategories.set(this.menuModel.searchItems(searchText));
        });

        onEach(this.menuModel.categorySelected$, () => this.dismiss());
    }

    override onActive(): void {
        setTimeout(() => this.inputER().nativeElement.focus(), 500);
    }
}
